import { addToast } from 'modules/messageSystem/actions/addToast';
import { updateUser } from './_api/updateUser';
import { invokeUploadAvatarFailureModal } from './avatarUpload';

export const saveAvatar = ({ logo }) => (dispatch, getState) => {
  const userData = getState().auth.userInfo.profile;

  const enhancedUserData = {
    ...userData,
    avatar: logo,
  };

  return dispatch(updateUser(enhancedUserData))
    .then(() => {
      return dispatch(addToast('success', 'user-avatar-saved', {
        id: 'MyAccount.Details.PhotoUpdated.Message',
        defaultMessage: '** Profile image successfully updated',
      }));
    })
    .catch((error) => {
      // fail
      return dispatch(invokeUploadAvatarFailureModal());
    });
};
